<template>
    <CContainer class="grapesjs-modal modal-birthday" fluid>
        <CRow>
            <CCol>
                <CTabs variant="tabs" :active-tab="0">
                    <!-- Tab general -->
                    <CTab :title="'general'">
                        <CCard bodyWrapper>
                            <CInput
                                :value.sync="label_text"

                                label="When is your birthday?"
                                placeholder='When is your birthday?'
                                size="sm"
                            />
                        </CCard>
                    </CTab>
                </CTabs>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
export default {
    name:"ModalBirthdayComponent",
    icons:{
        
    },
    components:{

    },
    data() {
        return {
            question_text:null,
            id:null,
            name:null,
            required:null,
            format:null,
            rank_min:null,
            rank_max:null,
            month_format:null,
        }
    },
    props:{
        editor:{
            required:true
        },
        opts:{
            required:true
        },
        payload:{
            required:true
        }
    },
    methods:{
        async loadData(){
            this.question_text = this.payload.question_text;
            this.format = this.payload.format;
            this.rank_min = this.payload.rank_min;
            this.rank_max = this.payload.rank_max;
            this.month_format = this.payload.month_format;
            this.id = this.payload.attributes.id;
            this.name = this.payload.attributes.name;
        },
        refreshTab(newValue){
        },
        closeModal(){
            this.editor.Modal.close();
        },
        saveChanges(){
            this.editor.runCommand('update-model-question-birthday', {
                component:this.payload.component,
                question_text:this.question_text,
                format:this.format,
                rank_min:this.rank_min,
                rank_max:this.rank_max,
                month_format:this.month_format,
                id:this.id,
                name:this.name,
                required:this.required,
            } );
            
            this.closeModal();
        }
    },
    async mounted(){
        await this.loadData();
    }
}
</script>

<style lang="scss">
    .grapesjs-modal.modal-birthday{
        .card{
            background: transparent;
        }

        .nav-tabs {
            border-bottom: 2px solid #dee2e6;
        }
    }
    
</style>